/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUpdateShiftsDataBaseData } from './BulkUpdateShiftsDataBaseData';
import {
    BulkUpdateShiftsDataBaseDataFromJSON,
    BulkUpdateShiftsDataBaseDataFromJSONTyped,
    BulkUpdateShiftsDataBaseDataToJSON,
    BulkUpdateShiftsDataBaseDataToJSONTyped,
} from './BulkUpdateShiftsDataBaseData';
import type { BulkUpdateShiftsDataShiftData } from './BulkUpdateShiftsDataShiftData';
import {
    BulkUpdateShiftsDataShiftDataFromJSON,
    BulkUpdateShiftsDataShiftDataFromJSONTyped,
    BulkUpdateShiftsDataShiftDataToJSON,
    BulkUpdateShiftsDataShiftDataToJSONTyped,
} from './BulkUpdateShiftsDataShiftData';

/**
 * 
 * @export
 * @interface BulkUpdateShiftsData
 */
export interface BulkUpdateShiftsData {
    /**
     * 
     * @type {BulkUpdateShiftsDataBaseData}
     * @memberof BulkUpdateShiftsData
     */
    baseData: BulkUpdateShiftsDataBaseData;
    /**
     * Values to update for sets of shifts
     * @type {Array<BulkUpdateShiftsDataShiftData>}
     * @memberof BulkUpdateShiftsData
     */
    shiftData: Array<BulkUpdateShiftsDataShiftData>;
}

/**
 * Check if a given object implements the BulkUpdateShiftsData interface.
 */
export function instanceOfBulkUpdateShiftsData(value: object): value is BulkUpdateShiftsData {
    if (!('baseData' in value) || value['baseData'] === undefined) return false;
    if (!('shiftData' in value) || value['shiftData'] === undefined) return false;
    return true;
}

export function BulkUpdateShiftsDataFromJSON(json: any): BulkUpdateShiftsData {
    return BulkUpdateShiftsDataFromJSONTyped(json, false);
}

export function BulkUpdateShiftsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateShiftsData {
    if (json == null) {
        return json;
    }
    return {
        
        'baseData': BulkUpdateShiftsDataBaseDataFromJSON(json['baseData']),
        'shiftData': ((json['shiftData'] as Array<any>).map(BulkUpdateShiftsDataShiftDataFromJSON)),
    };
}

  export function BulkUpdateShiftsDataToJSON(json: any): BulkUpdateShiftsData {
      return BulkUpdateShiftsDataToJSONTyped(json, false);
  }

  export function BulkUpdateShiftsDataToJSONTyped(value?: BulkUpdateShiftsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseData': BulkUpdateShiftsDataBaseDataToJSON(value['baseData']),
        'shiftData': ((value['shiftData'] as Array<any>).map(BulkUpdateShiftsDataShiftDataToJSON)),
    };
}

